import { ApolloClient, InMemoryCache, createHttpLink, from } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { MY_COMMERCIAL_QUERY } from "graphql/commercial";

// Bearer token is stored by auth flow in localStorage
const getBearerToken = () => {
  try {
    return localStorage.getItem("accessToken") || "";
  } catch {
    return "";
  }
};

// Apollo Client instance for commercial service
let commercialClient = null;

/**
 * Initialize Apollo Client for commercial service
 * @returns {ApolloClient} Configured Apollo Client instance
 */
function getCommercialClient() {
  if (commercialClient) {
    return commercialClient;
  }

  const httpLink = createHttpLink({
    uri: process.env.REACT_APP_DOORSHARP_GRAPHQL_ENDPOINT,
  });

  const authLink = setContext((_, { headers }) => ({
    headers: {
      ...headers,
      "Content-Type": "application/json",
      ...(getBearerToken() ? { Authorization: `Bearer ${getBearerToken()}` } : {}),
    },
  }));

  commercialClient = new ApolloClient({
    link: from([authLink, httpLink]),
    cache: new InMemoryCache(),
    defaultOptions: {
      query: {
        fetchPolicy: "network-only",
        errorPolicy: "all",
      },
    },
  });

  return commercialClient;
}

export async function fetchMyCommercialData(timePeriod = "YTD", highlightsTimePeriod = "YTD", filters = {}) {
  try {
    const client = getCommercialClient();

    const variables = { timePeriod, highlightsTimePeriod, filters, commercialFilters: filters };
    console.log("Commercial GraphQL variables:", variables);

    const { data } = await client.query({
      query: MY_COMMERCIAL_QUERY,
      variables,
      fetchPolicy: "network-only",
    });

    console.log("My Commercial Data GraphQL response:", data);
    return data;
  } catch (error) {
    console.error("My Commercial Data GraphQL error:", error);
    throw error;
  }
}
